<i class="{{ fontSet }} fa-{{ name }} {{ classes }}"
    aria-hidden="true"></i>